import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'SettingsAnnouncementEdit',
  props: {
    maintenance: {
      type: Object,
      default: () => ({}),
      required: true
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      formValid: false,
      createDialogButtons: [{
        icon: 'fas fa-save',
        title: this.$i18n_t('Common.save'),
        type: 'submit'
      }, {
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }],
      announcement: null
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'color'])
  },
  watch: {
    maintenance() {
      this.initData();
    }
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.announcement = this.maintenance;
    },
    revalidateForm() {
      this.$refs.mainForm.validate();
    },
    handleSubmit() {
      this.$emit('save', this.announcement);
    },
    closeDialog() {
      this.$emit('cancel-edit');
    },
    maintenanceToggleDate() {
      if (!!this.announcement.start && !!this.announcement.end) {
        delete this.announcement.start;
        delete this.announcement.end;
      } else {
        this.announcement.start = new Date();
        this.announcement.end = new Date(new Date() - -7 * 86400 * 1000);
      }
      this.announcement = cloneDeep(this.announcement);
    },
    maintenanceDatePicked(dateObject) {
      this.announcement.start = new Date(dateObject.from * 1000);
      this.announcement.end = new Date(dateObject.to * 1000);
    },
    maintenanceDate(start) {
      return new Date(start) / 1000;
    }
  }
};